export * from './admin-archiving-data-usage-api-client.service';
import { AdminArchivingDataUsageApiClient } from './admin-archiving-data-usage-api-client.service';
export * from './admin-archiving-data-usage-api-client.serviceInterface';
export * from './admin-archiving-gk-report-api-client.service';
import { AdminArchivingGkReportApiClient } from './admin-archiving-gk-report-api-client.service';
export * from './admin-archiving-gk-report-api-client.serviceInterface';
export * from './admin-archiving-report-api-client.service';
import { AdminArchivingReportApiClient } from './admin-archiving-report-api-client.service';
export * from './admin-archiving-report-api-client.serviceInterface';
export * from './admin-archiving-report-data-api-client.service';
import { AdminArchivingReportDataApiClient } from './admin-archiving-report-data-api-client.service';
export * from './admin-archiving-report-data-api-client.serviceInterface';
export * from './admin-archiving-usage-api-client.service';
import { AdminArchivingUsageApiClient } from './admin-archiving-usage-api-client.service';
export * from './admin-archiving-usage-api-client.serviceInterface';
export * from './admin-contracts-api-client.service';
import { AdminContractsApiClient } from './admin-contracts-api-client.service';
export * from './admin-contracts-api-client.serviceInterface';
export * from './admin-retention-api-client.service';
import { AdminRetentionApiClient } from './admin-retention-api-client.service';
export * from './admin-retention-api-client.serviceInterface';
export const APIS = [AdminArchivingDataUsageApiClient, AdminArchivingGkReportApiClient, AdminArchivingReportApiClient, AdminArchivingReportDataApiClient, AdminArchivingUsageApiClient, AdminContractsApiClient, AdminRetentionApiClient];
